import * as React from "react"
import * as ReactDOM from "react-dom"
import { Moment } from 'moment';

import { RentalAdvertPricing, Room } from '../../../types/types'

import { default as RoomPeriodPicker } from '../../../utils/period_picker/RoomPeriodPicker'
import { StartEnd } from '../../../utils/period_picker/PeriodPicker'
import { default as Select, ReactSelectProps } from 'react-select'
import { FocusedInputShape } from 'react-dates'
import Error from './error'
import RoomSelector from '../../../utils/period_picker/RoomSelector'

declare var I18n : { locale: string, t: (_:string) => string }

type Props = {
  arrival_date: Moment
  departure_date: Moment
  onDatesChange: (arg: { startDate: Moment | null, endDate: Moment | null }) => void
  onMaxPeopleChange: (value: number) => void
  max_people_select: number
  max_people: number
  room_id: number
  focusedInput: FocusedInputShape
  onFocusChange: (fi: FocusedInputShape) => void
  pricing: RentalAdvertPricing
  rooms: Room[]
  source: string
  onRoomChange: (value: number) => void
  closeScreen: () => void
}

type State = {
}

export default class BnbPeriodSelection extends React.Component<Props, State> {

  constructor(props, context) {
    super(props, context)
    this.state = {
    }
  }

  render() {
    let options = [<option key={`people_0`} value="">Selecteer...</option> /*Translation*/]
    for(let i = 1; i <= this.props.max_people_select; i++) {
      options.push(<option key={`people_${i}`} value={i}>{i}</option>)
    }
    return (
      <div>
        <div className="conversion-box__datepicker">
          <div className="conversion-box__labels">
            <span className="conversion-box__labels--when">{I18n.t("rental_adverts.booking_form.choose_room")}</span>
          </div>

          <RoomSelector
            room={this.props.room_id}
            rooms={this.props.rooms}
            source={this.props.source}
            onRoomChange={(value: number) => this.props.onRoomChange(value)}
          />

          <div className="conversion-box__labels">
            <span className="conversion-box__labels--when">{I18n.t("rental_adverts.booking_form.when")}</span>
          </div>

          <RoomPeriodPicker
            startDate={this.props.arrival_date}
            endDate={this.props.departure_date}
            onDatesChange={(range: StartEnd) => this.props.onDatesChange(range)}
            room_id={this.props.room_id}
            onFocusChange={this.props.onFocusChange}
            focusedInput={this.props.focusedInput}
            close={() => this.props.closeScreen()}
          />
        </div>

        <div className="conversion-box__persons">
          <div className="conversion-box__labels">
            <span className="conversion-box__labels--when">{I18n.t("rental_adverts.booking_form.max_people")}</span>
          </div>
          <select value={this.props.max_people || ''} onChange={(e) => this.props.onMaxPeopleChange(parseInt(e.target.value))}>
            {options}
          </select>
        </div>

        {
          this.props.pricing && this.props.pricing.error ?
          <div className="conversion-box__error">
            <Error
              pricing={this.props.pricing}
              close={() => this.props.closeScreen()}
            />
          </div>
          : null
        }

        <div className="conversion-box__button">
        {
          this.props.pricing ?
            (
              this.props.pricing.bookingLink
              ?
              <a href={this.props.pricing.bookingLink} className="btn btn--primary btn--block">{this.props.pricing.bookLabel}</a>
              :
              <a href="#" className="btn btn--primary disabled">{this.props.pricing.bookLabel}</a>

            )
          : null
        }
        </div>
        {
          this.props.pricing && this.props.pricing.withBookingModule ?
            <p className="conversion-box--secure-payment-text">{I18n.t('bookings.secure_payments.disclaimer')}</p>
          : null
        }
      </div>
    )
  }
}
